export const GetHoursAndMinutes = function (minutes, hours = 0) {
    if (minutes > 59) {
        hours += 1;
        minutes -= 60;
        return GetHoursAndMinutes(minutes, hours)
    }

    return {'minutes': minutes, 'hours': hours};
}
export const GetTimeWithDays = function (minutes, hours = 0, days = 0) {
    let hoursMinutes = GetHoursAndMinutes(minutes, hours);
    let result = GetDaysAndHoursAndMinutes(hoursMinutes.minutes, hoursMinutes.hours);
    return {'minutes': result.minutes, 'hours': result.hours, 'days': result.days};
}

export const GetDaysAndHoursAndMinutes = function (minutes, hours = 0, days = 0) {
    if (hours > 23) {
        days += 1;
        hours -= 24;
        return GetDaysAndHoursAndMinutes(minutes, hours, days)
    }

    return {'minutes': minutes, 'hours': hours, 'days': days};
}

export let StringInArray = function (str, arr ) {
    for(let i = arr.length; i--;) {
        let e = arr[i];
        if(str === e) return true;
    }
    return false;
}

export let TitleInArray = function (arr, title) {
    for(let i = arr.length; i--;) {
        let e = arr[i];
        if(title === e.title) return true;
    }
    return false;
}

export const IsNumeric = function (input) {
    return /^\d+$/.test(input);
}

export const GetNewUrl = function (qsKey, newValue, url) {
    if (!url) url = window.location.href;
    let re = new RegExp("([?&])" + qsKey + "=.*?(&|#|$)(.*)", "gi"),
        hash;

    if (re.test(url)) {
        if (typeof newValue !== 'undefined' && newValue !== null) {
            return url.replace(re, '$1' + qsKey + "=" + newValue + '$2$3');
        } else {
            hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        }
    } else {
        if (typeof newValue !== 'undefined' && newValue !== null) {
            let separator = url.indexOf('?') !== -1 ? '&' : '?';
            hash = url.split('#');
            url = hash[0] + separator + qsKey + '=' + newValue;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            return url;
        } else {
            return url;
        }
    }
}

export const HasOnlySpaces = function (string) {
    if (!string) return true;
    return /^\s*$/.test(string);
}

export const FilterPostsByTaxonomies = function (posts, categoryTypes, option = null) {
    if (!posts.length) return [];
    let result = [];
    if(typeof categoryTypes === 'string') categoryTypes = [categoryTypes]
    for (let i = 0; i < posts.length; i++) {
        const post = posts[i];
        const terms = post.terms;
        const termKeys = Object.keys(terms);
        for (let j = 0; j < termKeys.length; j++) {
            const cat = termKeys[j];
            if (StringInArray(cat, categoryTypes)) {
                for (let o = 0; o < terms[cat].length; o++) {
                    let identifier = null;
                    if(option === 'id') {
                        identifier = post.terms[cat][o].id + '';
                    } else if(option === 'slug') {
                        identifier = post.terms[cat][o].slug;
                    }
                    else {
                        identifier = post.terms[cat][o].name;
                    }
                    if (result[identifier] === undefined) {
                        result[identifier] = [post];
                    } else {
                        result[identifier] = [...result[identifier], post];
                    }
                }
            }
        }
    }

    return result;
}
export const GetTaxonomiesFromPosts = function (posts, categoryTypes) {
    if (!posts.length) return [];
    let result = [];
    if(typeof categoryTypes === 'string') categoryTypes = [categoryTypes]
    for (let i = 0; i < posts.length; i++) {
        const post = posts[i];
        const terms = post.terms;
        const termKeys = Object.keys(terms);
        for (let j = 0; j < termKeys.length; j++) {
            const cat = termKeys[j];
            if (StringInArray(cat, categoryTypes)) {
                for (let o = 0; o < terms[cat].length; o++) {
                    let findEl = result.filter(value => value.id === terms[cat][o].id)[0];
                    if(!findEl) {
                        result.push(terms[cat][o])
                    }
                }
            }
        }
    }

    return result;
}



export function ShuffleArray(array) {

    if(!array || !array.length) return [];
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle...
    while (currentIndex != 0) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }

    return array;
}